import React, { memo, ChangeEvent } from 'react'
import { Checkbox } from 'transfix-ui/components/Checkbox'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import { ISpotBiddingRule } from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import { InfoIcon } from 'transfix-icons'

interface IIsMultiStopProps {
  value: RecursivePartial<ISpotBiddingRule>
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
  dataTest?: string
}

export const IsMultiStop = memo<IIsMultiStopProps>(({ dataTest, onChange, value }) => {
  const { isMultiStop, mileageCriteria, transitDifferenceCriteria } = value

  const isMultiStopChangeHandler = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
    if (checked) {
      if (mileageCriteria !== undefined || !!transitDifferenceCriteria) {
        onChange({
          isMultiStop: checked,
          isDrop: !checked,
          stopSpecificDropCriteria: undefined,
          transitDifferenceCriteria: {
            timeUnit: 'day',
          },
        })
      } else {
        onChange({
          isMultiStop: checked,
          isDrop: !checked,
          stopSpecificDropCriteria: undefined,
        })
      }
    } else if (!!transitDifferenceCriteria && mileageCriteria !== undefined) {
      onChange({
        isMultiStop: checked,
        isDrop: checked,
        transitDifferenceCriteria: undefined,
      })
    } else {
      onChange({
        isMultiStop: checked,
        isDrop: checked,
      })
    }
  }

  const infoLabel = (
    <div>
      Is Multistop? <InfoIcon />
    </div>
  )

  return mileageCriteria !== undefined ? (
    <div className='row' data-test={dataTest}>
      <div className='col-md-6 col-xs-6'>
        <Tooltip
          position='left'
          trigger={
            <span>
              <Checkbox
                label={infoLabel}
                checked={isMultiStop}
                onChange={isMultiStopChangeHandler}
              />
            </span>
          }>
          Rules are applied to total multi-stop mileage
        </Tooltip>
      </div>
    </div>
  ) : (
    <div className='row' data-test={dataTest}>
      <div className='col-md-6 col-xs-6'>
        <Tooltip
          position='left'
          trigger={
            <span>
              <Checkbox
                label={infoLabel}
                checked={isMultiStop}
                onChange={isMultiStopChangeHandler}
              />
            </span>
          }>
          Rules are applied to first pickup and last delivery
        </Tooltip>
      </div>
    </div>
  )
})
